import React from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { CUSTOMIZED } from './customizedProjectsJson';
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";

function Cosmetics(props) {
  // const { t } = useTranslation(["translation", "aboutUs"]);

  return (
    <>
      <Helmet>
        <title>Custom Luxury Packaging Solutions for Products | Lussopack</title>
        <meta name="description" content="Let's craft your masterpiece products with our custom packaging solutions. We specialize in creating elegant packaging such as wine & perfume boxes, and more." />
        <meta name="keywords" content="custom luxury packaging" />
        <link rel="canonical" href="https://lussopack.com/packaging/" />  
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"Customized Projects"}
        textSubHeader={"We are here to turn your dream of impeccable luxury packaging into a tangible reality."}
        isShowOurReference={true}
      />

      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="customized">
            <h2 className="text-center">Customized Projects</h2>
            <div className="customizedList">
              {
                CUSTOMIZED.map((customized, index)=>(
                  <div className={`customizedItem`}>
                    <Link  key={index} to={toRoute(customized.path)}>
                      <Image
                        src={asset(`${customized.itemImageDesktop}`)}
                        alt={`${customized.item}`}
                        className="img-fluid zoom"
                        width="345"
                        height="345"
                      />
                    </Link>
                    <Link key={index} to={toRoute(customized.path)}>
                      <p className="text-center mt-2">{customized.item}</p>
                    </Link>
                      <span>{customized.itemDescription}</span>
                  </div>
                ))
              }
            </div>
            <div className="descriptionConatainer">
              <p>Driven by a passion for innovation and a commitment to uncompromising quality, we pledge to collaborate closely with each client, transforming their visions into tangible works of art that resonate with their brand essence and values. Our team has been producing customized projects for customers in various industries, such as cosmetics, spirits, and fashion. Specializing in creating luxurious packaging for items such as <b>Wine Boxes, Perfume Boxes</b> and Skincare Gift Set Boxes.</p>
              <h3>Our Customization Abilities</h3>
              <p>We believe that your imagination sets the limit, and we are here to turn your dream of impeccable luxury packaging into a <b>tangible reality.</b> Our Customization Abilities include <b>creating 3D rendering, designing, and prototyping.</b> Every step of the way, we empower you to infuse your unique vision, style, and branding elements, ensuring that the final product is a reflection of your distinct identity. Our dedicated team of experts will collaborate with you to fully understand your ideas in order to craft each detail to perfection.</p>
              <p>We are not just service providers; we are partners in transforming your aspirations into a finely crafted masterpiece. Experience the fusion of artistry and functionality as we merge innovation with sophistication, offering you luxury packaging that goes beyond expectations. Your dream is the cornerstone of our craftsmanship, and we are dedicated to turning it into a tangible testament of elegance and excellence.</p>
              
              <p>At Lussopack, we understand that every business is different. That's why we offer a wide range of customized packaging solutions to meet the unique needs of our customers. We can help you create custom packaging that is:</p>
              <div className="listContainer">
                <ul>
                  <li><b>Functional</b> : We design packaging that protects your products during shipping and handling.</li>
                  <li><b>Brand-consistent</b> : We create packaging that reflects your brand identity and values.</li>
                  <li><b>Eye-catching</b> : We design packaging that stands out on the shelf and captures the attention of consumers.</li>
                </ul>
              </div>

              <p className="notIndent">We offer a variety of customization options, including:</p>
              <div className="listContainer">
                <ul>
                  <li><b>Materials</b> : We use a variety of materials to create custom packaging, including cardboard, corrugated plastic, and wood.</li>
                  <li><b>Printing</b> : We offer a variety of printing options, including offset, digital, and flexographic printing.</li>
                  <li><b>Finishing</b> : We offer a variety of finishing options, such as die-cutting, embossing, and lamination.</li>
                </ul>
              </div>
            
            <h4 className="notIndent"><b>Industries that we served:</b></h4>
            <div className="listContainer">
              <ul>
                <li>Food and beverage</li>
                <li>Personal care</li>
                <li>Household goods</li>
                <li>Electronics</li>
                <li>Industrial</li>
                <li>Automotive</li>
                <li>Medical devices</li>
                <li>E-commerce</li>
                <li>Retail</li>
                <li>Logistics</li>
              </ul>
            </div>
            
            <h4 className="notIndent"><b>Our Process</b></h4>
            <div className="listContainer">
                <p><b>Consultation</b> : We begin by understanding your brand, your vision, and your product line. This ensures that every aspect of the packaging aligns perfectly with your identity.</p>
                <p><b>Design and Customization</b> : Our talented design team works closely with you to create a bespoke packaging solution. You have the final say in every detail, from color tones to finishing touches.</p>
                <p><b>Production and Quality Control</b> : Using innovative technology and craftsmanship, we bring your designs to life. Each piece undergoes rigorous quality checks to ensure it meets our exacting standards.</p>
                <p><b>Delivery</b> : Your customized gold packaging is carefully packaged and delivered to your location, ready to enhance your brand's presence in the market.</p>
            </div>
            
            </div>
          </div>
        </Media>
          <Media lessThan="md">
          <div id="customizedMobile">
              <h2>Customized Projects</h2>
              <div className="customizedList">
                {
                  CUSTOMIZED.map((customized, index)=>(
                      <Link className={`customizedItem`} key={index} to={toRoute(customized.path)}>
                        <Image
                          src={asset(`${customized.itemImageDesktop}`)}
                          alt={`${customized.item}`}
                          className="img-fluid"
                          width="345"
                          height="345"
                        />
                        <p>{customized.item}</p>
                        <span>{customized.itemDescription}</span>
                      </Link>
                  ))
                }
              </div>
              <div className="descriptionConatainer">
                <p>Driven by a passion for innovation and a commitment to uncompromising quality, we pledge to collaborate closely with each client, transforming their visions into tangible works of art that resonate with their brand essence and values. Our team has been producing customized projects for customers in various industries, such as cosmetics, spirits, and fashion. Specializing in creating luxurious packaging for items such as <b>Wine Boxes, Perfume Boxes</b> and Skincare Gift Set Boxes.</p>
                <h3>Our Customization Abilities</h3>
                <p>We believe that your imagination sets the limit, and we are here to turn your dream of impeccable luxury packaging into a <b>tangible reality.</b> Our Customization Abilities include <b>creating 3D rendering, designing, and prototyping.</b> Every step of the way, we empower you to infuse your unique vision, style, and branding elements, ensuring that the final product is a reflection of your distinct identity. Our dedicated team of experts will collaborate with you to fully understand your ideas in order to craft each detail to perfection.</p>
                <p>We are not just service providers; we are partners in transforming your aspirations into a finely crafted masterpiece. Experience the fusion of artistry and functionality as we merge innovation with sophistication, offering you luxury packaging that goes beyond expectations. Your dream is the cornerstone of our craftsmanship, and we are dedicated to turning it into a tangible testament of elegance and excellence.</p>
                
                <p>At Lussopack, we understand that every business is different. That's why we offer a wide range of customized packaging solutions to meet the unique needs of our customers. We can help you create custom packaging that is:</p>
                <div className="listContainer">
                  <ul>
                    <li><b>Functional</b> : We design packaging that protects your products during shipping and handling.</li>
                    <li><b>Brand-consistent</b> : We create packaging that reflects your brand identity and values.</li>
                    <li><b>Eye-catching</b> : We design packaging that stands out on the shelf and captures the attention of consumers.</li>
                  </ul>
                </div>

                <p className="notIndent">We offer a variety of customization options, including:</p>
                <div className="listContainer">
                  <ul>
                    <li><b>Materials</b> : We use a variety of materials to create custom packaging, including cardboard, corrugated plastic, and wood.</li>
                    <li><b>Printing</b> : We offer a variety of printing options, including offset, digital, and flexographic printing.</li>
                    <li><b>Finishing</b> : We offer a variety of finishing options, such as die-cutting, embossing, and lamination.</li>
                  </ul>
                </div>
              
              <h4 className="notIndent"><b>Industries that we served:</b></h4>
              <div className="listContainer">
                <ul>
                  <li>Food and beverage</li>
                  <li>Personal care</li>
                  <li>Household goods</li>
                  <li>Electronics</li>
                  <li>Industrial</li>
                  <li>Automotive</li>
                  <li>Medical devices</li>
                  <li>E-commerce</li>
                  <li>Retail</li>
                  <li>Logistics</li>
                </ul>
              </div>
              
              <h4 className="notIndent"><b>Our Process</b></h4>
              <div className="listContainer">
                  <p><b>Consultation</b> : We begin by understanding your brand, your vision, and your product line. This ensures that every aspect of the packaging aligns perfectly with your identity.</p>
                  <p><b>Design and Customization</b> : Our talented design team works closely with you to create a bespoke packaging solution. You have the final say in every detail, from color tones to finishing touches.</p>
                  <p><b>Production and Quality Control</b> : Using innovative technology and craftsmanship, we bring your designs to life. Each piece undergoes rigorous quality checks to ensure it meets our exacting standards.</p>
                  <p><b>Delivery</b> : Your customized gold packaging is carefully packaged and delivered to your location, ready to enhance your brand's presence in the market.</p>
              </div>
              
              </div>
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default Cosmetics;
